import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const CreateTicketModal = ({ onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    subject: '',
    description: '',
    category: 'general'
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setSubmitting(true);
    await onCreate(formData);
    setSubmitting(false);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-card border border-border rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto overflow-elegant"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="p-6 md:p-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl font-heading font-bold text-foreground mb-1">
                Create Support Ticket
              </h2>
              <p className="text-sm text-muted-foreground flex items-center gap-2">
                <Icon name="Sparkles" size={14} className="text-primary" />
                AI will analyze and route your ticket automatically
              </p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              iconName="X"
              iconSize={20}
              aria-label="Close modal"
            />
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Subject *
              </label>
              <Input
                value={formData?.subject}
                onChange={(e) => handleChange('subject', e?.target?.value)}
                placeholder="Brief description of your issue"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Category *
              </label>
              <select
                value={formData?.category}
                onChange={(e) => handleChange('category', e?.target?.value)}
                required
                className="w-full px-4 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="general">General Inquiry</option>
                <option value="billing">Billing & Payments</option>
                <option value="membership">Membership</option>
                <option value="technical">Technical Issue</option>
                <option value="facility">Facility & Equipment</option>
                <option value="class_booking">Class Booking</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Description *
              </label>
              <textarea
                value={formData?.description}
                onChange={(e) => handleChange('description', e?.target?.value)}
                placeholder="Provide detailed information about your issue or question"
                rows={6}
                required
                className="w-full px-4 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>

            <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Icon name="Info" size={18} className="text-blue-500 mt-0.5" />
                <div className="text-sm text-foreground">
                  <p className="font-medium mb-1">AI-Powered Support</p>
                  <p className="text-muted-foreground">
                    Our AI will analyze your ticket to determine priority, route it to the right department, and may provide an automated response for common issues.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <Button
                type="button"
                variant="outline"
                onClick={onClose}
                className="flex-1"
                disabled={submitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="default"
                className="flex-1"
                iconName="Send"
                iconPosition="left"
                loading={submitting}
                disabled={submitting}
              >
                Submit Ticket
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateTicketModal;